import CustomerSelect from './CustomerSelect';

export default CustomerSelect;


// WEBPACK FOOTER //
// ./src/components/Others/CustomerSelect/index.tsx